import { css } from 'styled-components';
import { responsive } from '@design-system/theme';
import { getBgColor } from './getBgColor';
import { ARROW_SIZE, POSITIONS } from '../constants';
export const renderTriangle = ({ tooltipPosition }) => {
    switch (tooltipPosition) {
        case POSITIONS.TOP:
            return css `
        border-top: ${ARROW_SIZE}px solid ${getBgColor};
        border-right: ${ARROW_SIZE}px solid transparent;
        border-left: ${ARROW_SIZE}px solid transparent;
      `;
        case POSITIONS.RIGHT:
            return css `
        border-bottom: ${ARROW_SIZE}px solid ${getBgColor};
        border-right: ${ARROW_SIZE}px solid transparent;
        border-left: ${ARROW_SIZE}px solid transparent;
        ${responsive('m') `
           border-top: ${ARROW_SIZE}px solid transparent;
           border-bottom: ${ARROW_SIZE}px solid transparent;
           border-right: ${ARROW_SIZE}px solid ${getBgColor};
           border-left: none;
         `}
      `;
        case POSITIONS.BOTTOM:
            return css `
        border-bottom: ${ARROW_SIZE}px solid ${getBgColor};
        border-right: ${ARROW_SIZE}px solid transparent;
        border-left: ${ARROW_SIZE}px solid transparent;
      `;
        case POSITIONS['BOTTOM-RIGHT']:
            return css `
        border-bottom: ${ARROW_SIZE}px solid ${getBgColor};
        border-right: ${ARROW_SIZE}px solid transparent;
        border-left: ${ARROW_SIZE}px solid transparent;
      `;
        case POSITIONS['TOP-RIGHT']:
            return css `
        border-top: ${ARROW_SIZE}px solid ${getBgColor};
        border-right: ${ARROW_SIZE}px solid transparent;
        border-left: ${ARROW_SIZE}px solid transparent;
      `;
        case POSITIONS.LEFT:
            return css `
        border-bottom: ${ARROW_SIZE}px solid ${getBgColor};
        border-right: ${ARROW_SIZE}px solid transparent;
        border-left: ${ARROW_SIZE}px solid transparent;

        ${responsive('m') `
           border-top: ${ARROW_SIZE}px solid transparent;
           border-bottom: ${ARROW_SIZE}px solid transparent;
           border-left: ${ARROW_SIZE}px solid ${getBgColor};
           border-right: none;
         `}
      `;
        default:
            return '';
    }
};
//# sourceMappingURL=renderTriangle.js.map